module.exports = {
	"id": "SD",
	"name": "Sudan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.006384,
			"5": 0.009576,
			"6": 0.003192,
			"7": 0.003192,
			"8": 0.009576,
			"9": 0.036708,
			"10": 0.038304,
			"11": 0.057456,
			"12": 0.006384,
			"13": 0.004788,
			"14": 0.003192,
			"15": 0.001596,
			"16": 0.028728,
			"17": 0.011172,
			"18": 0.012768,
			"19": 0.017556,
			"20": 0.014364,
			"21": 0.006384,
			"22": 0.04788,
			"23": 0.035112,
			"24": 0.027132,
			"25": 0.0399,
			"26": 0.054264,
			"27": 0.065436,
			"28": 0.054264,
			"29": 0.145236,
			"30": 0.036708,
			"31": 0.084588,
			"32": 0.03192,
			"33": 0.11172,
			"34": 0.038304,
			"35": 0.03192,
			"36": 0.044688,
			"37": 0.020748,
			"38": 0.035112,
			"39": 0.070224,
			"40": 0.118104,
			"41": 0.038304,
			"42": 0.044688,
			"43": 0.553812,
			"44": 0.068628,
			"45": 0.094164,
			"46": 0.09576,
			"47": 0.126084,
			"48": 0.114912,
			"49": 0.201096,
			"50": 0.188328,
			"51": 0.537852,
			"52": 0.405384,
			"53": 0.855456,
			"54": 0.1596,
			"55": 0.004788,
			"56": 0.001596,
			"57": null
		},
		"firefox": {
			"2": 0.003192,
			"3": 0.05586,
			"4": 0.006384,
			"5": 0.012768,
			"6": 0.006384,
			"7": 0.003192,
			"8": 0.004788,
			"9": 0.009576,
			"10": 0.014364,
			"11": 0.019152,
			"12": 0.038304,
			"13": 0.011172,
			"14": 0.011172,
			"15": 0.017556,
			"16": 0.020748,
			"17": 0.012768,
			"18": 0.022344,
			"19": 0.020748,
			"20": 0.012768,
			"21": 0.011172,
			"22": 0.02394,
			"23": 0.01596,
			"24": 0.00798,
			"25": 0.01596,
			"26": 0.01596,
			"27": 0.011172,
			"28": 0.006384,
			"29": 0.030324,
			"30": 0.030324,
			"31": 0.014364,
			"32": 0.012768,
			"33": 0.038304,
			"34": 0.0399,
			"35": 0.041496,
			"36": 0.052668,
			"37": 0.035112,
			"38": 0.0399,
			"39": 0.04788,
			"40": 0.043092,
			"41": 0.04788,
			"42": 0.0399,
			"43": 0.29526,
			"44": 0.1197,
			"45": 0.11172,
			"46": 0.098952,
			"47": 0.647976,
			"48": 0.461244,
			"49": 3.187212,
			"50": 0.35112,
			"51": 0.003192,
			"52": 0.001596,
			"3.5": 0.006384,
			"3.6": 0.033516
		},
		"opera": {
			"9": null,
			"11": 0.004788,
			"12": 0.011172,
			"15": 0.004788,
			"16": 0.003192,
			"17": 0.001596,
			"18": 0.004788,
			"19": 0.004788,
			"20": 0.003192,
			"21": 0.003192,
			"22": 0.003192,
			"23": null,
			"24": null,
			"25": 0.001596,
			"26": 0.003192,
			"27": 0.001596,
			"28": 0.006384,
			"29": 0.00798,
			"30": 0.006384,
			"31": null,
			"32": 0.00798,
			"33": 0.012768,
			"34": 0.012768,
			"35": 0.020748,
			"36": 0.043092,
			"37": 0.035112,
			"38": 0.020748,
			"39": 0.051072,
			"40": 0.579348,
			"41": 0.078204,
			"42": 0.006384,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.006384,
			"11.1": 0.001596,
			"11.5": 0.044688,
			"11.6": 0.014364,
			"12.1": 0.049476
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006384,
			"6": null,
			"7": 0.017556,
			"8": 0.017556,
			"9": 0.043092,
			"10": 0.102144,
			"3.1": null,
			"3.2": null,
			"5.1": 0.012768,
			"6.1": null,
			"7.1": null,
			"9.1": 0.057456
		},
		"ios_saf": {
			"8": 0,
			"10": 0.97089641632,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0261645349709,
			"8.1-8.4": 0.0483378696919,
			"9.0-9.2": 0.0230602681099,
			"9.3": 0.351816910908
		},
		"android": {
			"3": 0,
			"4": 0.17572394832,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0219654935401,
			"4.1": 0.633861385013,
			"4.2-4.3": 1.58465346253,
			"4.4": 3.63372021705,
			"4.4.3-4.4.4": 3.66509949354
		},
		"ie": {
			"6": 0.00645149603524,
			"7": 0.00645149603524,
			"8": 0.738696296035,
			"9": 0.10806255859,
			"10": 0.0661278343612,
			"11": 0.904822318943,
			"5.5": null
		},
		"op_mob": {
			"0": 2.7940687421,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0776130206138
		},
		"edge": {
			"12": 0.081396,
			"13": 0.089376,
			"14": 0.126084
		},
		"ie_mob": {
			"10": 0.0347996619718,
			"11": 0.141684338028
		},
		"bb": {
			"7": 0.006303,
			"10": null
		},
		"samsung": {
			"0": 3.69776
		},
		"and_uc": {
			"0": 13.412784
		},
		"op_mini": {
			"0": 37.6440022373
		},
		"and_chr": {
			"0": 14.73672
		},
		"and_ff": {
			"0": 0.033616
		}
	},
	"total": 98.254211
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SD.json
 ** module id = 640
 ** module chunks = 0
 **/